import React from 'react';

import { Rules as CommonRules } from '../common';

export const Rules = () => {
  return <CommonRules />;
};
